import { Playground, Props } from 'docz';
import { Menu } from "../../../../../src/components/Menu.tsx";
import { Home, Info, SettingsApplications, Collections, ContactMail } from '@material-ui/icons';
import t from 'prop-types';
import * as React from 'react';
export default {
  Playground,
  Props,
  Menu,
  Home,
  Info,
  SettingsApplications,
  Collections,
  ContactMail,
  t,
  React
};